"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trustedLoginChallengeSessionRepository = void 0;
const resolver_1 = require("./resolver");
const mapper_1 = require("./mapper");
exports.trustedLoginChallengeSessionRepository = {
    getSession: async (api, progressId) => {
        const response = await (0, resolver_1.fetchTrustedLoginChallengeSession)(api, progressId);
        return (0, mapper_1.mapVerifyTrustedLoginSession)(response.data);
    },
};
//# sourceMappingURL=repository.js.map